import { ChangeEvent, FC, HTMLAttributes, useState } from 'react'
import Icon from './Icon'
import { useBreakpoint } from '../hooks/use-breakpoint'

interface Props extends HTMLAttributes<HTMLDivElement> {
  options: {
    label?: string
    value: string
    disable?: boolean
    width?: number
  }[]
  selected: string
  onOptionSelect: (value: string) => void
  selectClassName?: string
  responsiveWidth?: boolean
}
const Dropdown: FC<Props> = ({
  options,
  selected,
  onOptionSelect,
  className,
  selectClassName = '',
  style = {},
  id,
  ...rest
}) => {
  const [selectedOption, setSelectedOption] = useState(selected)
  const { md } = useBreakpoint()

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    onOptionSelect(e.target.value)
    setSelectedOption(e.target.value)
  }

  const selectedOptionWidth = options.find(
    option => option.value === selectedOption
  )?.width

  return (
    <div
      className={`FormControl ${className}`}
      {...rest}
      style={{
        width: selectedOptionWidth
          ? (md ? selectedOptionWidth : selectedOptionWidth * 0.85) + 'em'
          : undefined,
        ...style
      }}
    >
      <label className="FormLabel visually-hidden" htmlFor={id}>
        City
      </label>
      <select
        id={id}
        className={`FormSelect ${selectClassName}`}
        value={selectedOption}
        onChange={handleChange}
        style={{ textTransform: 'none' }}
      >
        {options.map(option => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disable}
          >
            {option.label || option.value}
          </option>
        ))}
      </select>
      <Icon
        variant="caret-down"
        className="FormSelect-arrow Icon Icon--xs"
        style={{ right: '1rem' }}
      />
    </div>
  )
}

export default Dropdown
